import { render, staticRenderFns } from "./EnergyProductionChart.vue?vue&type=template&id=1f637adb&scoped=true&"
import script from "./EnergyProductionChart.vue?vue&type=script&lang=js&"
export * from "./EnergyProductionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f637adb",
  null
  
)

export default component.exports